var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TransparentButton } from "./..";
import { useTheme } from "../../hooks";
import { noop } from "../../utils";
var buildLss = function (isSelected, isCintTheme) { return ({
    m: 'unset',
    px: 'md',
    lineHeight: '2rem',
    textTransform: 'none',
    letterSpacing: 'none',
    fontWeight: 'regular',
    cursor: 'pointer',
    position: 'relative',
    justifyContent: 'center',
    ':focus': {
        outline: 'none',
        bg: 'gray100',
        borderBottom: 'thick',
        borderBottomColor: isSelected
            ? isCintTheme
                ? 'danger500'
                : 'secondary500'
            : 'gray100'
    },
    color: isSelected ? (isCintTheme ? 'primary500' : 'secondary500') : 'gray700',
    borderBottom: 'thick',
    borderBottomColor: isSelected
        ? isCintTheme
            ? 'danger500'
            : 'secondary500'
        : 'transparent'
}); };
export var Tab = function (_a) {
    var id = _a.id, isSelected = _a.isSelected, _b = _a.onSelect, onSelect = _b === void 0 ? noop : _b, accessibilityLabel = _a.accessibilityLabel, children = _a.children, lss = _a.lss, idDescriptor = _a.idDescriptor;
    var theme = useTheme();
    var isCintTheme = theme.template === 'CINT';
    return (React.createElement(TransparentButton, { id: idDescriptor ? idDescriptor + "-tab-" + id : "tab-" + id, role: "tab", lss: __assign(__assign({}, buildLss(isSelected, isCintTheme)), lss), tabIndex: isSelected ? undefined : -1, "aria-selected": isSelected, "aria-label": accessibilityLabel, onClick: function (e) {
            e.preventDefault();
            onSelect(id);
        } }, children));
};
//# sourceMappingURL=Tab.js.map